import { isQrWaiterOrder } from "../../../services/QrWaiter";
import { siteGroups } from "..";
export const cartPromotionsView = {
    name: "CartPromotionsView",
    variants: [
        ["Control", 4],
        ["Test", 1],
    ],
    controlVariant: "Control",
    apply: (assignVariant, clearVariant) => {
        const isTesting = localStorage.getItem("fieldTestExperimentsTest") !== null;
        const isProduction = Skubacz.configuration.environment === "production";
        const validSiteId = siteGroups.odd(Skubacz.configuration.site_id);
        const validCountry = Skubacz.configuration.country === "PL";
        const validSource = !isQrWaiterOrder() && !Skubacz.Device.isMobileApp();
        const validTheme = ["fiesta", "vesspa", "new_vision", "pasja"].includes(Skubacz.configuration.theme_name);
        // dev && e2e & QA - do nothing, allow to set the variant manually via localStorage
        if (!isProduction || isTesting) {
            return;
        }
        // production conditions
        if (validSiteId && validCountry && validSource && validTheme) {
            assignVariant();
        }
        else {
            clearVariant();
        }
    },
};
